<template>
  <div class="container-fluid">
  <!-- <div class="container"> -->
    <ad-header></ad-header>
    <router-view />
    <ad-footer></ad-footer>
  </div>
</template>

<script>
  import Header from './components/Header.vue';
  import Footer from './components/Footer.vue';

  export default {
    components: {
      'ad-header': Header,
      'ad-footer': Footer
    }
  }
</script>

<style>
  @import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

  .uh-header {
    padding: 20px 0px;
    text-align: center;
  }
  .uh-login {
    padding: 20px 0px;
  }
  .uh-portal {
    padding: 5px 15px;
  }
  .uh-footer {
    padding: 20px 5px 10px 5px;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue